import React from 'react';
import PropTypes from 'prop-types';
import RegisterForm from '../components/RegisterForm'
import {connect} from 'react-redux';
import {clearError, registerRequest} from '../actions/auth'
import {fetchAllSystems} from '../actions/system'
class ForgotPassword extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchAllSystems())
    this.props.dispatch(clearError())
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const form = this.form
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {
        systemID,
        fullName,
        email,
        userName,
        phone,
        password,
        confirmPassword
      } = values
      const info = {
        system_id: systemID,
        fullname: fullName,
        username: userName,
        email: email,
        phone: phone,
        password: password,
        passwordconfirm: confirmPassword
      }
      this.props.dispatch(registerRequest(info));
    });
  };

  saveFormRef = (form) => {
    this.form = form;
  };

  render() {
    const {fetching, error, systems} = this.props
    return <RegisterForm ref={this.saveFormRef} error={error} fetching={fetching} systems={systems} onSubmit={this.handleSubmit}/>
  }
}

ForgotPassword.propTypes = {
  dispatch: PropTypes.func,
  fetching: PropTypes.bool,
  systems: PropTypes.array,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {error: state.auth.error, fetching: state.auth.fetching, systems: state.system.systems}
}

export default connect(mapStateToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/Register.js